import { DecreaseOrderList } from '@ui/features/Trade/components/DecreaseOrderList/DecreaseOrderList';
import { getActiveDecreaseOrders } from '@ui/services/contract/hooks/TradingPortalFacet/useDecreaseOrders/selectors';
import { useDecreaseOrders } from '@ui/services/contract/hooks/TradingPortalFacet/useDecreaseOrders/useDecreaseOrders';
import { usePositions } from '@ui/hooks/trade/usePositions';
import { Text } from '@ui/lib/park/ui/text';
import { useTranslation } from 'next-i18next';
import { Center } from 'styled-system/jsx';
import type { Address } from 'viem';

export const DecreaseOrders = ({
  hideFilters,
  userAddress,
}: {
  hideFilters?: boolean;
  userAddress?: Address;
}) => {
  const { data: orders } = useDecreaseOrders({ userAddress });
  const { data: positions } = usePositions(userAddress);

  return (
    <DecreaseOrderList
      orders={getActiveDecreaseOrders(orders)}
      positions={positions || []}
      emptyView={<Empty />}
      showCurrentPairToggle={!hideFilters}
    />
  );
};

const Empty = () => {
  const { t } = useTranslation();

  return (
    <Center py="6">
      <Text textStyle="v2.ui" color="v2.text.subtle">
        {t("common.You currently don't have any decrease orders.")}
      </Text>
    </Center>
  );
};
